// Subscribe to the meta Y.Map and return the current RetroMeta. Re-renders
// when any meta field changes (mode flip, phase advance, timer set, etc.).
// Pattern mirrors useShapes: observeDeep + a version counter.

import { useEffect, useMemo, useState } from 'react';
import * as Y from 'yjs';
import type { RetroMeta } from '@frame/shared';
import { getMetaMap, readMeta } from './binding/metaMap';

export function useRetroMeta(doc: Y.Doc): RetroMeta {
  const yMeta = useMemo(() => getMetaMap(doc), [doc]);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const handler = () => setVersion((v) => v + 1);
    yMeta.observe(handler);
    return () => yMeta.unobserve(handler);
  }, [yMeta]);

  return useMemo(
    () => readMeta(doc),
    // version is the cache-buster; doc identity rarely changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [doc, version],
  );
}
